import { FC, useState } from 'react';
import { IconLink } from '../icon-link';

import { CloudUpload, Envelope, Heart } from '../../assets';
import { ShareMessages } from '../share-messages';

export interface QuickLinksProps {
  personalPageUrl?: string;
}

export const QuickLinks: FC<QuickLinksProps> = ({ personalPageUrl }) => {
  const [shareMessageModal, setShareMessageModal] = useState(false);

  const handleShareMessage = () =>
    setShareMessageModal((prevState) => !prevState);

  const primaryLink = 'brand.additional.link';

  const colorProps = {
    textColor: primaryLink,
    iconColor: primaryLink,
  };

  return (
    <>
      <IconLink icon={CloudUpload} {...colorProps} to="/check-deposit">
        Deposit
        <br />
        Check
      </IconLink>
      <IconLink icon={Heart} to="/donations" {...colorProps}>
        Thank My
        <br />
        Donors
      </IconLink>

      <IconLink
        icon={Envelope}
        {...colorProps}
        to=""
        onClick={handleShareMessage}
      >
        Share a
        <br />
        Message
      </IconLink>
      {shareMessageModal && (
        <ShareMessages
          isOpen={shareMessageModal}
          onClose={handleShareMessage}
          personalPageUrl={personalPageUrl || ''}
        />
      )}
    </>
  );
};
